export const Callout = ({ children }: { children: React.ReactNode }) => {
  return (
    <span className="inline-block w-fit rounded-full bg-secondary px-2 py-0.5 text-xs font-medium text-secondary-foreground uppercase">
      {children}
    </span>
  );
};
